module.exports = __webpack_public_path__ + "img/money-euro-box-fill.a532fdf8.svg";